<template>
  <span
    >Welcome to <b>Way Admin</b></span
  >
</template>

<script>
export default {
  name: "notification-template",
};
</script>
